import { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import "../../../UserDashboard/components/UserDashboardHome/UserDashboardHome.css";
import "../../../UserDashboard/components/StatementTable/StatementTable.css";
import localeText from "../../../../locale";
import { Toast } from "primereact/toast";
import { Column } from "primereact/column";
import { locale } from "../../../../utilities/locale/locale";
import handleLocale from "../../../../utilities/LocaleSwitch";
import { FilterMatchMode } from "primereact/api";
import AdminService from "../../../../service/AdminService";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { InputText } from "primereact/inputtext";
import { typeTransfer } from "../../../UserDashboard/components/WithdrawIntent/WithdrawIntent";
import { formatPrice } from "../../../../utilities/formatPrice";

const ListWithdrawRequests = () => {
  const [loading, setLoading] = useState(false);
  const [withdrawRequests, setWithdrawRequests] = useState([]);
  const [filteredWithdrawRequests, setFilteredWithdrawRequests] = useState([]);
  const [selectedWithdrawRequest, setSelectedWithdrawRequest] = useState("");
  const [processVisible, setProcessVisible] = useState(false);
  const [currentWithdrawRequest, setCurrentWithdrawRequest] = useState(null);
  const adminService = new AdminService();
  const toast = useRef(null);

  const filters2 = {
    paypalEmailToTransfer: { value: null, matchMode: FilterMatchMode.CONTAINS },
    bankname: { value: null, matchMode: FilterMatchMode.CONTAINS },
    iban: { value: null, matchMode: FilterMatchMode.CONTAINS },
    accountOwner: { value: null, matchMode: FilterMatchMode.CONTAINS },
  };

  function formatDate(date) {
    date = new Date(date);

    const dd = date.getUTCDate();
    const mm = date.getUTCMonth() + 1;
    const yy = date.getUTCFullYear();

    return dd + "/" + mm + "/" + yy;
  }

  useEffect(() => {
    let cancel = false;

    fetchWithdrawRequests(cancel);

    return () => {
      cancel = true;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchWithdrawRequests(cancel) {
    try {
      setLoading(true);
      const res = await adminService.getAllWithdrawRequests(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );
      if (cancel) return;

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        setWithdrawRequests(res.result);
        setFilteredWithdrawRequests(res.result);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setLoading(false);
      console.log(e);
    }
  }

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  async function processRequest(id) {
    try {
      setLoading(true);
      const res = await adminService.postProcessWithdraw(
        localStorage.getItem("__extraconomy_token"),
        id,
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        toast.current.show({
          severity: "error",
          summary: localeText("error"),
          detail: localeText("data").find((msg) => msg.code === res.messageCode).message,
          life: 6000,
        });
        if (res.messageCode === 500000) console.log(res);
        setLoading(false);
      } else {
        toast.current.show({
          severity: "success",
          summary: localeText("success"),
          detail: localeText("withdrawProcessedSuccessfully"),
          life: 6000,
        });

        fetchWithdrawRequests(false);
        setLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      console.log(e);
    }
  }

  const filterByWithdrawRequests = (withdraw) => {
    if (withdraw) {
      const filteredData = withdrawRequests.filter(
        (obj) =>
          obj?.userprocess?.firstname.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.userprocess?.surname.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.accountOwner?.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.bankname?.toLowerCase().includes(withdraw.toLowerCase()) ||
          obj?.iban?.toLowerCase().includes(withdraw.toLowerCase())
      );
      setFilteredWithdrawRequests([...filteredData]);
    } else {
      setFilteredWithdrawRequests(withdrawRequests);
    }
  };

  return (
    <div className="card border-1 border-300">
      <ConfirmDialog
        visible={processVisible}
        onHide={() => {
          setCurrentWithdrawRequest(null);
          setProcessVisible(false);
        }}
        message={localeText("processThisRequest")}
        header={localeText("confirmYourAction")}
        icon="pi pi-exclamation-triangle"
        accept={() => processRequest(currentWithdrawRequest.id)}
        reject={() => {
          setCurrentWithdrawRequest(null);
          setProcessVisible(false);
        }}
        acceptLabel={localeText("confirm")}
        rejectLabel={localeText("cancel")}
      />

      <Toast ref={toast} />

      <h3 className="my-4">{localeText("withdrawRequests")}</h3>

      <p>{localeText("searchByNameSurnameUserAccountBank")}:</p>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "justify-content",
          alignItems: "center",
        }}
      >
        <InputText
          className="w-100"
          name="tracking"
          value={selectedWithdrawRequest}
          onChange={(e) => {
            setSelectedWithdrawRequest(e.target.value);
            filterByWithdrawRequests(e.target.value);
          }}
          placeholder={localeText("search")}
        />
      </div>
      <hr />

      <DataTable
        className="mt-4 mb-6 p-datatable-customers"
        value={filteredWithdrawRequests}
        paginator
        responsiveLayout="scroll"
        loading={loading}
        dataKey="id"
        filters={filters2}
        filterDisplay="row"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate={localeText("showingFirstToLast")}
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
      >
        <Column
          header={`Email (PayPal) | ${localeText("bank")}`}
          body={(withdrawRequest) => {
            const isBankTransfer = !withdrawRequest.paypalEmailToTransfer;
            const isPaypalTransfer = !!withdrawRequest?.paypalEmailToTransfer;
            return (
              <>
                {isPaypalTransfer && <p>{withdrawRequest.paypalEmailToTransfer}</p>}

                {isBankTransfer && (
                  <>
                    <p className="mb-1 mt-0">
                      {localeText("name")}: {`${withdrawRequest?.accountOwner}`}{" "}
                    </p>
                    <p className="mb-1 mt-0">
                      {localeText("bank")}: {`${withdrawRequest.bankname}`}
                    </p>
                    <p className="mb-0 mt-0">
                      {localeText("bankAccountNumber")}: {`${`${withdrawRequest?.iban}`}`}
                    </p>
                  </>
                )}
              </>
            );
          }}
          filter
          filterPlaceholder={localeText("searchByEmail")}
          filterField={"paypalEmailToTransfer"}
          filters={filters2}
          filterDisplay="row"
        />
        <Column field="userprocess.username" header={localeText("processedBy")} />
        <Column
          header={localeText("requestDate")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.dateRequest && (
                  <div>{formatDate(withdrawRequest.dateRequest)}</div>
                )}
              </>
            );
          }}
        />
        <Column
          header={localeText("processDate")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.dateProcess && (
                  <div>{formatDate(withdrawRequest.dateProcess)}</div>
                )}
              </>
            );
          }}
        />
        <Column
          field="amountRequested"
          header={localeText("amountRequested")}
          body={(withdrawRequest) => {
            let currentCurrency = withdrawRequest.currency;
            return (
              <p>
                {currentCurrency} {formatPrice(withdrawRequest.amountRequested)}
              </p>
            );
          }}
        />
        <Column
          field="amountToDeposit"
          header={localeText("amountToDeposit")}
          body={(withdrawRequest) => {
            let currentCurrency = withdrawRequest.currency;
            return (
              <p>
                {currentCurrency} {formatPrice(withdrawRequest.amountToDeposit)}
              </p>
            );
          }}
        />
        <Column
          field="fee"
          header={capitalizeFirstLetter(localeText("withdrawFee"))}
          body={(withdrawRequest) => {
            let currentCurrency = withdrawRequest.currency;

            return (
              <p>
                {currentCurrency} {formatPrice(withdrawRequest.fee)}
              </p>
            );
          }}
        />
        <Column
          header={localeText("status")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.status === "COMPLETED" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#46a748" }}
                  >
                    {withdrawRequest.status === "COMPLETED" &&
                      localeText("completed").toUpperCase()}
                  </span>
                )}
                {withdrawRequest.status === "PROCESSING" && (
                  <span
                    className="team-member-role text-0 p-1 border-round"
                    style={{ backgroundColor: "#F7B005" }}
                  >
                    {withdrawRequest.status === "PROCESSING" &&
                      localeText("processing").toUpperCase()}
                  </span>
                )}
              </>
            );
          }}
        />
        <Column
          header={localeText("processRequest")}
          body={(withdrawRequest) => {
            return (
              <>
                {withdrawRequest.status === "PROCESSING" && (
                  <Button
                    label={localeText("process")}
                    icon="pi pi-check"
                    className="p-button-success p-button-rounded"
                    onClick={() => {
                      setProcessVisible(true);
                      setCurrentWithdrawRequest(withdrawRequest);
                    }}
                  />
                )}
              </>
            );
          }}
        />
      </DataTable>
    </div>
  );
};

export default ListWithdrawRequests;
